// css from styled components renders out css higlights and block definition.
import { css } from "styled-components";

import { setTextColor } from "./setTextColor";
import { setThemeColor } from "./setThemeColor";

// this is a styled-component mixin for the typography in the project

export const typographyMixin = css`
  @import url("https://fonts.googleapis.com/css2?family=Graduate&family=Rubik:wght@300;400;500;600;700;800;900&display=swap");

  // for the font we can also create a preview-head.html file in the ./storybook dir and add it with a <link /> tag
  // see https://storybook.js.org/docs/react/configure/story-rendering

  font-family: "Rubik", "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;

  color: ${setTextColor("primary")};

  &.xxl {
    font-size: 2.5rem;
  }
  &.h1,
  h1 {
    font-size: 2.1875rem;
  }
  &.xl {
    font-size: 2rem;
  }
  &.h2,
  h2 {
    font-size: 1.75rem;
  }
  &.h3,
  h3 {
    font-size: 1.53125rem;
  }
  &.lg {
    font-size: 1.5rem;
  }
  &.h4,
  h4 {
    font-size: 1.3125rem;
  }
  &.h5,
  h5 {
    font-size: 1.09375rem;
  }
  &.md {
    font-size: 1rem;
  }
  &.h6,
  h6 {
    font-size: 0.875rem;
  }
  &.sm {
    font-size: 0.8rem;
  }
  &.xs {
    font-size: 0.7rem;
  }
  &.xxs {
    font-size: 0.6rem;
  }
`;

const component = ["xxl", "xl", "lg", "md", "sm", "xs", "xxs"];

const header = ["h1", "h2", "h3", "h4", "h5", "h6"];

/// this combines all size options for the stories.
export const sizes = {
  component,
  header,
  all: [...component, ...header],
};

export const themeOptions = [
  "primary",
  "inverted",
  "secondary",
  "muted",
  "success",
  "danger",
  "info",
];

interface ButtonStyles {
  main: string;
  secondary: string;
}

// This exports an object of colors based on the theme being passed in.
// The StyledButton uses this to create color-pairs and access them via main or secondary on the object.
export const setButtonStyle = (theme: string): ButtonStyles => {
  let buttonStyle: ButtonStyles = { main: "", secondary: "" };
  buttonStyle.main = setThemeColor(theme);
  buttonStyle.secondary = setTextColor(theme);
  return buttonStyle;
};
